var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-float",staticStyle:{"background-color":"navy","height":"8rem"}},[_c('WizardHeader'),_c('b-row',{staticStyle:{"margin-top":"2rem"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('QuestionsList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }